class UserService {
  static get userAgent() {
    return window.navigator.userAgent;
  }
}

export default UserService;
